module.exports = __webpack_public_path__ + "assets/img/10_768_big.24bfb0af.jpg";